import React from "react";
import {Stepper} from "@stepperize/react";
import {CreateProjectStep} from "../stepper/create-project-steps.ts";
import ProjectInformationsStep from "./create-project-informations-step.tsx";
import CreateProjectImportPlansStep from "./create-project-import-plans-step.tsx";
import CreateProjectOrganisationDetailsStep from "./create-project-organisation-details-step.tsx";
import CreateProjectProcessingStep from "./create-project-processing-step.tsx";

const renderCreateProjectStep = (stepper: Stepper<CreateProjectStep[]>): React.ReactNode => {
    const stepId = stepper.current.id;
    switch (stepId) {
        case "project-info":
            return <ProjectInformationsStep stepper={stepper}/>;

        case "pdf-selection":
            return <CreateProjectImportPlansStep stepper={stepper}/>;

        case "building-floor-preview":
            return <CreateProjectOrganisationDetailsStep stepper={stepper}/>;

        case "creation":
            return <CreateProjectProcessingStep/>;

        default:
            return null;
    }
};

export default renderCreateProjectStep;